import { combineReducers } from "@reduxjs/toolkit";
import vaccineTemplateReducer from "./slices/template/vaccineTemplateSlice";

export const rootReducer = combineReducers({
  vaccineTemplate: vaccineTemplateReducer,
});

export type RootReducerState = ReturnType<typeof rootReducer>;
